import { Button } from '@cian/ui-kit';
import * as React from 'react';

export interface IBuilderCallReasonsContactButtonProps {
  loading?: boolean;
  onClick?: () => void;
}

export const BuilderCallReasonsContactButton: React.VFC<IBuilderCallReasonsContactButtonProps> = ({
  loading = false,
  onClick,
}) => {
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <Button loading={loading} onClick={handleClick} size="XS" theme="fill_primary">
      Позвонить застройщику
    </Button>
  );
};
